import { api } from '../abTestsApiSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        postAbTestsV1ParticipantsAssignVariantTestSlug: build.mutation({
            query: (queryArg) => ({
                url: `/ab_tests/v1/participants/assign_variant/${queryArg.testSlug}`,
                method: 'POST',
                body: queryArg.postAbTestsV1ParticipantsAssignVariantTestSlug,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as abTestsApi };
export const { usePostAbTestsV1ParticipantsAssignVariantTestSlugMutation } = injectedRtkApi;
